import { render } from "./swatchView.vue?vue&type=template&id=b34f4262"
import script from "./swatchView.vue?vue&type=script&lang=js"
export * from "./swatchView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__